<template>
	<div>
		<div class="headline">Timeline</div>

		<v-alert :value="stats.length === 0" type="warning">
			JobStats are missing
		</v-alert>

		<div v-if="stats.length > 0">
			<v-row v-if="attempts.length > 1">
				<v-col cols="2">
					<v-select :items="attempts" v-model="attempt"></v-select>
				</v-col>
			</v-row>

			<component v-bind:is="statType" :stat="stat" :created="created"></component>
		</div>
	</div>
</template>
<script>
import statAnalysis from "./job-stats-analysis.vue";
import statPkg from "./job-stats-pkg.vue";
import statReport from "./job-stats-report.vue";
import statSnapshot from "./job-stats-snapshot.vue";

export default {
	props: ["stats", "type", "created"],
	components: {
		statAnalysis,
		statPkg,
		statReport,
		statSnapshot,
	},
	data() {
		return {
			attempt: 0,
		};
	},
	computed: {
		stat() {
			return this.stats[this.attempt];
		},
		attempts() {
			return this.stats.map((s, i) => ({ text: `Attempt #${s.attemptNumber}`, value: i }));
		},
		statType() {
			return `stat${this.type}`;
		},
	},
	methods: {
	},
};
</script>
<style scoped>
.event {
	color: #0D47A1;
}
</style>
